import { analytics } from './sdk';

/**
 * Coerce a server-returned points value to a finite number.
 * Falls back when the value is missing or not numeric.
 */
export function coerceRewardPoints(
  serverValue: unknown,
  fallback = 0,
): number {
  if (serverValue === null || serverValue === undefined) {
    return fallback;
  }
  const parsed = Number(serverValue);
  return Number.isFinite(parsed) ? parsed : fallback;
}

/**
 * Emit `reward_earned` after a server-driven mint succeeds with > 0 points.
 * Matches the payload shape from usePointsService.awardPoints (pre-REK-1547).
 */
export function trackRewardEarned(
  amount: unknown,
  sourceFeature: string,
  options?: { fallback?: number },
): void {
  const fallback = options?.fallback ?? 0;
  const rewardAmount = coerceRewardPoints(amount, fallback);
  if (rewardAmount <= 0) {
    return;
  }

  analytics.trackEvent({
    name: 'reward_earned',
    properties: {
      reward_type: 'points',
      reward_amount: rewardAmount,
      source_feature: sourceFeature,
    },
  });
}
